import { render, staticRenderFns } from "./NotifDetail.vue?vue&type=template&id=4c2e33ae&scoped=true&"
import script from "./NotifDetail.vue?vue&type=script&lang=ts&"
export * from "./NotifDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NotifDetail.vue?vue&type=style&index=0&id=4c2e33ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e33ae",
  null
  
)

export default component.exports